// Race dates are calendar days stored as UTC midnight ("2026-10-11", or epoch ms at 00:00Z in calendar.json).
// Formatting them in the viewer's timezone shows the day before for anyone west of UTC, so always format as UTC.

export const formatRaceDate = (value, options, locale = "en-US") => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleDateString(locale, { ...options, timeZone: "UTC" });
};

export const raceMonthShort = (value) => formatRaceDate(value, { month: "short" });

export const getRaceYear = (value) => new Date(value).getUTCFullYear();

// Whole calendar days from the viewer's today to the race day (0 on race day itself)
export const daysUntilRace = (value, now = new Date()) => {
  const race = new Date(value);
  if (Number.isNaN(race.getTime())) return 0;
  const raceDay = Date.UTC(race.getUTCFullYear(), race.getUTCMonth(), race.getUTCDate());
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.max(0, Math.round((raceDay - today) / 86400000));
};
